import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'user-avatar',
    template: `
        <div class="btn-icon" id="nav-user-avatar" aria-hidden="true">
            <span>
                <i class="fa-solid fa-user"></i>
            </span>
        </div>
    `,
    styles: [
        `
            #nav-user-avatar {
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #ededed;
                background: #f5f7fb;
                width: 35px;
                height: 35px;
                border-radius: 5px;

                i {
                    color: var(--coma-accent);
                    font-size: 20px;
                }
            }
        `,
    ],
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {}
